/**
 * @author       denys.yefremov@startupsoft.co (Denys Yefremov)
 * @copyright    Copyright (c) 2022, Zumper
 */

import { css } from '@emotion/react'

export const messageForm = css`
  width: 360px;
  flex: 0 0 360px;
  background: transparent;
`

export const loaderContainer = css`
  margin: 20px 0;
`

export const messageFormPlaceholder = css`
  box-shadow: 0 4px 16px 0 rgb(0 0 0 / 10%);
  box-sizing: border-box;
`

export const textPlaceholder = css`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 15px;
  height: 55px;
`
